export interface ChatMessage {
  id: string;
  role: 'user' | 'assistant' | 'system';
  content: string;
  timestamp: Date;
}

export interface ChatRequest {
  message: string;
  sessionId?: string;
  maxTokens?: number;
  temperature?: number;
  systemPrompt?: string;
}

export interface ChatResponse {
  response: string;
  sessionId?: string;
  timestamp?: string;
}

// Local storage models
export interface ChatSession {
  id: string;
  title: string;
  messages: ChatMessage[];
  createdAt: Date;
  lastUpdated: Date;
}

export interface ChatSessionStorage {
  sessions: ChatSession[];
  lastUpdated: Date;
}

// Constants
export const CHAT_PRESETS = [
  {
    name: 'General Assistant',
    systemPrompt: 'You are a helpful AI assistant. Be concise and clear in your responses.',
    temperature: 0.7
  },
  {
    name: 'Creative Writer',
    systemPrompt: 'You are a creative writing assistant. Help with storytelling, poetry, and creative expression.',
    temperature: 0.9
  },
  {
    name: 'Code Helper',
    systemPrompt: 'You are a programming assistant. Help with coding questions, debugging, and technical explanations.',
    temperature: 0.3
  },
  {
    name: 'Study Buddy',
    systemPrompt: 'You are an educational assistant. Help explain concepts clearly and provide learning support.',
    temperature: 0.5
  },
  {
    name: 'Brainstorming Partner',
    systemPrompt: 'You are a brainstorming assistant. Help generate ideas and explore possibilities creatively.',
    temperature: 0.8
  }
];